<template>
  <v-container
    :fluid="!authUser"
    class="pt-8 px-8 sisa-font"
    style="width: 850px"
    :style="{
      'background-color': 'white',
      'padding-left': authUser ? '48px' : '40px',
    }"
  >
    <!-- Snackbar -->
    <v-snackbar
      v-model="snack"
      :color="snackColor"
      :timeout="snackTime"
      bottom
      right
    >
      {{ snackText }}
    </v-snackbar>

    <!-- CONFIRM DIALOG -->
    <v-dialog v-model="confirmDialog" persistent max-width="400">
      <v-card>
        <v-card-title class="headline sisa-text">
          {{ confirmTitle }}
        </v-card-title>
        <v-card-text class="subtitle-1"> {{ confirmText }} </v-card-text>
        <v-card-actions class="px-6 pb-4">
          <v-btn color="sisa" outlined @click="confirmDialog = false">
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="sisa" dark @click="confirmAction"> Continuar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- LOADING ENCUESTA -->
    <v-dialog v-model="loading" persistent width="300">
      <v-card color="sisa" dark>
        <v-card-text>
          Cargando Encuesta...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-form ref="form" v-model="valid" lazy-validation>
      <v-row class="d-flex py-3 pt-10 flex-column">
        <h2 class="py-2 mb-2 text-center">
          Encuesta de <span class="sisa-text">Satisfacción</span>
        </h2>

        <v-form ref="formRechazo" lazy-validation>
          <v-card
            max-width="850"
            class="mb-3 pb-0"
            v-if="authUser && !encabezado.completada"
          >
            <v-card-title class="pl-6">
              <v-switch
                v-model="encabezado.rechazada"
                inset
                :readonly="rechazadaEnBase || encabezado.completada"
                label="Cliente Rechaza Encuesta"
              ></v-switch>
              <v-spacer></v-spacer>
              <v-switch
                v-model="encabezado.noContesta"
                inset
                :readonly="noContestaEnBase || encabezado.completada"
                label="Asegurado No Contesta"
              ></v-switch>
              <v-spacer></v-spacer>
              <v-switch
                v-model="encabezado.envioLink"
                inset
                :readonly="envioLinkEnBase || encabezado.completada"
                label="Se Envia Encuesta Via Link"
              ></v-switch>
            </v-card-title>
            <v-card-text
              v-if="
                encabezado.rechazada ||
                encabezado.noContesta ||
                encabezado.envioLink
              "
            >
              <v-textarea
                no-resize
                v-model="encabezado.motivoRechazo"
                color="sisa"
                label="Comentario"
                :rules="requiredRule"
                counter="500"
                :readonly="rechazadaEnBase || encabezado.completada"
                outlined
              ></v-textarea>
              <v-row
                v-if="
                  encabezado.rechazada ||
                  encabezado.noContesta ||
                  encabezado.envioLink
                "
              >
                <v-spacer></v-spacer>
                <v-col cols="auto">
                  <v-btn
                    @click="clienteRechazaEncuesta"
                    color="sisa"
                    width="150"
                    dark
                    :block="$vuetify.breakpoint.smAndDown"
                    :disabled="
                      encabezado.completada ||
                      rechazadaEnBase ||
                      envioLinkEnBase ||
                      noContestaEnBase ||
                      encuestaEnviada ||
                      loading
                    "
                    >Guardar</v-btn
                  >
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-form>

        <v-card
          v-for="(pregunta, index) in preguntas"
          :key="pregunta.preguntaId"
          max-width="850"
          class="mb-3 pb-0"
        >
          <v-card-title class="font-weight-bold" style="word-break: keep-all"
            >{{ index + 1 }}. {{ pregunta.textoPregunta }}</v-card-title
          >
          <v-card-text>
            <v-divider></v-divider>
            <v-radio-group
              v-if="encabezado.completada"
              v-model="pregunta.respuestas[0].respuesta"
              :column="$vuetify.breakpoint.smAndDown"
              class="pl-8"
              :rules="requiredRule"
              :readonly="deshabilitarEdicion"
            >
              <v-radio
                v-for="(opcion, i) in getOpcionesRespuesta(
                  pregunta.posiblesRespuestas
                )"
                :key="opcion + i"
                color="sisa"
                :label="opcion"
                :value="opcion"
              ></v-radio>
            </v-radio-group>
            <v-radio-group
              v-else
              v-model="pregunta.respuestas.respuesta"
              :column="$vuetify.breakpoint.smAndDown"
              class="pl-8"
              :rules="requiredRule"
              :readonly="deshabilitarEdicion"
            >
              <v-radio
                v-for="(opcion, i) in getOpcionesRespuesta(
                  pregunta.posiblesRespuestas
                )"
                :key="opcion + i"
                color="sisa"
                :label="opcion"
                :value="opcion"
              ></v-radio>
            </v-radio-group>

            <v-textarea
              no-resize
              v-if="
                getMalasRespuestas(pregunta.posiblesRespuestas).includes(
                  pregunta.respuestas.respuesta
                )
              "
              :rules="
                getMalasRespuestas(pregunta.posiblesRespuestas).includes(
                  pregunta.respuestas.respuesta
                )
                  ? requiredRule
                  : []
              "
              color="sisa"
              v-model.trim="pregunta.respuestas.comentario"
              :readonly="deshabilitarEdicion"
              label="Por favor, explica tu respuesta"
              counter="500"
              outlined
            ></v-textarea>
          </v-card-text>
        </v-card>
      </v-row>
      <v-row class="pt-0 pb-5 mt-0">
        <v-spacer></v-spacer>
        <v-btn
          @click="showConfirmDatos"
          color="sisa"
          width="200"
          dark
          :block="$vuetify.breakpoint.smAndDown"
          :disabled="
            !valid || encabezado.completada || encuestaEnviada || loading
          "
          >Enviar</v-btn
        >
      </v-row>
    </v-form>
  </v-container>
</template>
<script>
import axios from "axios";
import router from "../router";

export default {
  name: "EncuestaSisa",
  data: () => ({
    encabezado: [],
    preguntas: [],
    cabinaId: null,
    rechazadaEnBase: false,
    noContestaEnBase: false,
    envioLinkEnBase: false,
    encuestaEnviada: false,
    valid: true,
    confirmTitle: "Confirmación",
    confirmText:
      "Esta acción es irreversible, si selecciona continuar no podrá realizar cambios en sus respuestas.",
    snack: false,
    snackColor: "primary",
    snackText: "",
    snackTime: 4000,
    confirmDialog: false,
    requiredRule: [(v) => !!v || "Campo Requerido"],
    loading: false,
  }),
  computed: {
    authUser() {
      return !!this.$store.state.token;
    },
    deshabilitarEdicion() {
      return this.encabezado.completada || this.encuestaEnviada;
    },
  },
  watch: {
    preguntas: {
      handler(pregunta) {
        // Limpieza de Comentarios Si se Cambia de Respuesta
        Object.keys(pregunta).forEach((key) => {
          const current = this.preguntas[key];
          const requiereComentario = this.getMalasRespuestas(
            current.posiblesRespuestas
          ).includes(current.respuestas.respuesta);
          if (!requiereComentario) {
            this.preguntas[key].respuestas.comentario = null;
          }
        });
      },
      deep: true,
    },
  },
  created() {
    const asistencia = this.$route.params.asistencia;
    this.getEncuesta(asistencia);
  },
  mounted() {},
  methods: {
    clienteRechazaEncuesta() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      if (this.$refs.formRechazo.validate()) {
        axios
          .put(
            `/Sisa/Encuestas/${this.encabezado.numeroAsistencia}`,
            {
              rechazada: this.encabezado.rechazada,
              motivoRechazo: this.encabezado.motivoRechazo,
              noContesta: this.encabezado.noContesta,
              envioLink: this.encabezado.envioLink,
            },
            configuracion
          )
          .then((res) => {
            this.rechazadaEnBase = true;
            this.noContestaEnBase = true;
            this.envioLinkEnBase = true;

            this.snackText = "Encuesta Actualizada!";
            this.snack = true;
            this.snackColor = "primary";
          })
          .catch((err) => {
            this.rechazadaEnBase = false;
          });
      }
    },
    getEncuesta(asistenciaID) {
      if (!asistenciaID) {
        router.push({ name: "login" }).catch(() => {});
      }

      let configuracion = null;
      if (this.authUser) {
        let header = { Authorization: "Bearer " + this.$store.state.token };
        configuracion = { headers: header };
      }

      this.loading = true;

      axios
        .get(
          `/Sisa/Encuestas/${asistenciaID}`,
          configuracion == null ? null : configuracion
        )
        .then((res) => {
          this.encabezado = res.data;
          this.preguntas = res.data.preguntas;
          this.cabinaId = asistenciaID;

          this.rechazadaEnBase = this.encabezado.rechazada;
          this.envioLinkEnBase = this.encabezado.envioLink;
          this.noContestaEnBase = this.encabezado.noContesta;

          if (this.encabezado.completada && !this.authUser) {
            router.push({ name: "login" }).catch(() => {});
          }
        })
        .catch((err) => {
          console.error(err);
          router.push({ name: "login" }).catch(() => {});
        })
        .finally(() => (this.loading = false));
    },
    getOpcionesRespuesta(posiblesRespuestas) {
      return posiblesRespuestas ? posiblesRespuestas.split(", ") : [];
    },
    getMalasRespuestas(posiblesRespuestas) {
      const respuestas = this.getOpcionesRespuesta(posiblesRespuestas);

      const totalMalasRespuestas = respuestas.length > 2 ? 2 : 1;

      const malasRespuestas = respuestas.slice(
        Math.max(respuestas.length - totalMalasRespuestas, 0)
      );
      return malasRespuestas;
    },
    enviarEncuesta() {
      if (this.$refs.form.validate()) {
        let configuracion = null;
        if (this.authUser) {
          let header = { Authorization: "Bearer " + this.$store.state.token };
          configuracion = { headers: header };
        }

        const respuestasMap = this.preguntas.map((pregunta) => {
          return {
            preguntaId: pregunta.preguntaId,
            respuesta: pregunta.respuestas.respuesta,
            comentario: pregunta.respuestas.comentario,
          };
        });

        axios
          .post(
            "/Sisa/Encuestas/GuardarRespuestas",
            {
              cabinaId: this.cabinaId,
              encuestaId: this.encabezado.encuestaId,
              respuesta: respuestasMap,
            },
            configuracion == null ? null : configuracion
          )
          .then((res) => {
            this.snackText = "Encuesta Enviada, Puede Cerrar Esta Ventana!";
            this.snack = true;
            this.snackColor = "primary";

            this.encuestaEnviada = true;
          })
          .catch((err) => {
            console.error(err);
            this.snackText = "La Encuesta No Fue Enviada!";
            this.snack = true;
            this.snackColor = "error";
          })
          .finally(() => {
            this.confirmDialog = false;
          });
      } else {
        this.confirmDialog = false;
      }
    },
    confirmAction() {
      this.enviarEncuesta();
    },
    showConfirmDatos() {
      this.confirmDialog = true;
    },
  },
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Titillium+Web:ital,wght@0,200;0,300;0,400;0,600;0,700;0,900;1,200;1,300;1,400;1,600;1,700&display=swap");
.sisa-text {
  color: #0078ff;
}
.sisa-font {
  font-family: "Titillium Web", sans-serif;
}
</style>